import Select from '@components/v2/form/Select/Select';
import LangEnum from '../../../lang/LangEnum';
import { SatisfactionSurveyAudience } from '../../../services/modules/satisfactionSurveySettings/satisfactionSurveySettings.types';
import { useTranslation } from '../../translation/TranslationContext';
import { SatisfactionSurveySettingsSectionProps } from '../satisfactionSurveySettings.types';

const audienceLabels: Record<SatisfactionSurveyAudience, LangEnum> = {
  [SatisfactionSurveyAudience.CUSTOMER]: LangEnum.SATISFACTION_SURVEY_SETTINGS_AUDIENCE_CUSTOMER,
  [SatisfactionSurveyAudience.SALES_REP]: LangEnum.SATISFACTION_SURVEY_SETTINGS_AUDIENCE_SALES_REP,
  [SatisfactionSurveyAudience.BRAND_ADMIN]:
    LangEnum.SATISFACTION_SURVEY_SETTINGS_AUDIENCE_BRAND_ADMIN,
};

const SatisfactionSurveyAudienceSelect = ({
  settings,
  isDisabled,
  onChange,
}: SatisfactionSurveySettingsSectionProps) => {
  const { translate } = useTranslation();

  const options = Object.values(SatisfactionSurveyAudience).map((audience) => ({
    value: audience,
    label: translate(audienceLabels[audience]),
    disabled: settings.audiences.length === 1 && settings.audiences[0] === audience,
  }));

  return (
    <Select
      multiple
      sx={{ minWidth: 280 }}
      disabled={isDisabled}
      label={translate(LangEnum.SATISFACTION_SURVEY_SETTINGS_AUDIENCES_LABEL)}
      value={settings.audiences}
      options={options}
      onChange={(event) => {
        const audiences = event.target.value as SatisfactionSurveyAudience[];

        if (audiences.length === 0) {
          return;
        }

        onChange({ audiences });
      }}
    />
  );
};

export default SatisfactionSurveyAudienceSelect;
